module.exports = __webpack_public_path__ + "media/react/gre/organisms/checkpoints/assets/test_day-cb9b9c74604b8084c6fc1db20fe9af9e.svg";